import { createFileRoute } from "@tanstack/react-router";

import {
  SmartActionBoard,
  SmartActionsGuard,
} from "@/features/office/smart-actions";
import { smartActionBoardSearchSchema } from "@/features/office/smart-actions/_configs/board-search-schema";

export const routeId = "/office/smart-actions/board";

export const Route = createFileRoute("/office/smart-actions/board")({
  validateSearch: smartActionBoardSearchSchema,
  component: SmartActionBoardRoute,
});

/**
 * Smart Actions is behind `rollout_smart_actions` and the ADMIN / MANAGER role
 * (the platform refuses everyone else), the deep link included. The guard
 * renders nothing until Statsig and the signed-in user have loaded.
 */
function SmartActionBoardRoute() {
  return (
    <SmartActionsGuard>
      <SmartActionBoard />
    </SmartActionsGuard>
  );
}
